import { IOccupation } from '../models';

export function fromJsonApi(data: any[]): IOccupation[] {
  return data.map((item) => {
    const { id, attributes: { name } } = item;

    return {
      id,
      name,
    };
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/occupations.ts